import { useEffect, useState } from "react";
import ProfileHeaderLoaderMobile from "../ProfileHeaderLoader/profileHeaderLoaderMobile/ProfileHeaderLoaderMobile";
import ProfileHeaderLoader from "../ProfileHeaderLoader/ProfileHeaderLoader";
import ProfileHeaderWeb from "./ProfileHeaderWeb";
import ProfileHeaderMobile from "./ProfileHeaderMobile";

function ProfileHeader(props) {
	const [profileName, setProfileName] = useState(props.name);
	const [profileDescription, setProfileDescription] = useState(
		props.description
	);
	const [shareSheetOpen, setShareSheetOpen] = useState(false);
	const handleShareSheetClose = () => setShareSheetOpen(false);
	const [profileAvatarImage, setProfileAvatarImage] = useState(null);
	const [profileBannerImage, setProfileBannerImage] = useState(null);
	const [linkedinProfileEditUrl, setLinkedinProfileEditUrl] = useState("");

	useEffect(() => {
		setProfileName(props.name);
		setProfileDescription(props.description);
		setLinkedinProfileEditUrl(props.linkedinProfileUrl);
	}, [props.name, props.description, props.linkedinProfileUrl]);

	useEffect(() => {
		setProfileAvatarImage(null);
		setProfileBannerImage(null);
		setProfileName(props.name);
		setProfileDescription(props.description);
		setLinkedinProfileEditUrl(props.linkedinProfileUrl);
	}, [props.editModeActive]);

	function cancelProfileChanges() {
		setProfileName(props.name);
		setProfileDescription(props.description);
		setLinkedinProfileEditUrl(props.linkedinProfileUrl);
		setProfileAvatarImage(null);
		setProfileBannerImage(null);
		props.cancelEditMode();
	}

	return props.isLoading ? (
		<ProfileHeaderLoader isMobile={props.isMobile} />
	) : props.isMobile ? (
		<ProfileHeaderMobile
			profileName={profileName}
			name={props.name}
			profileDescription={profileDescription}
			profileAvatarEditImage={profileAvatarImage}
			setProfileName={setProfileName}
			setProfileDescription={setProfileDescription}
			setProfileAvatarEditImage={setProfileAvatarImage}
			profileBannerEditImage={profileBannerImage}
			setProfileBannerEditImage={setProfileBannerImage}
			cancelProfileChanges={cancelProfileChanges}
			linkedinProfileEditUrl={linkedinProfileEditUrl}
			shareSheetOpen={shareSheetOpen}
			addTranslation={props.addTranslation}
			updateWalletProfile={props.updateWalletProfile}
			handleShareSheetClose={handleShareSheetClose}
			setShareSheetOpen={setShareSheetOpen}
			setLinkedinProfileEditUrl={setLinkedinProfileEditUrl}
			{...props}
		/>
	) : (
		<ProfileHeaderWeb
			profileName={JSON.parse(JSON.stringify(profileName))}
			profileDescription={profileDescription}
			profileAvatarEditImage={profileAvatarImage}
			name={props.name}
			setProfileName={setProfileName}
			setProfileDescription={setProfileDescription}
			setProfileAvatarEditImage={setProfileAvatarImage}
			profileBannerEditImage={profileBannerImage}
			setProfileBannerEditImage={setProfileBannerImage}
			cancelProfileChanges={cancelProfileChanges}
			linkedinProfileEditUrl={linkedinProfileEditUrl}
			shareSheetOpen={shareSheetOpen}
			updateWalletProfile={props.updateWalletProfile}
			addTranslation={props.addTranslation}
			handleShareSheetClose={handleShareSheetClose}
			setShareSheetOpen={setShareSheetOpen}
			setLinkedinProfileEditUrl={setLinkedinProfileEditUrl}
			{...props}
		/>
	);
}

export default ProfileHeader;
